import commonMixin from '../../mixins/_common';
import modalMixin from './../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';
import specValues from './_spec_values_component';

/**
 * 商品スペックのリストコンポーネント
 */
const specList = {
    name: 'specList',
    template: '#spec_list_template',
    props: {
        // スペック情報
        specs: {
            type: Array,
        },
        // 選択されている商品スペック
        selected_specs: {
            type: Array,
        },
    },
    components: {
        // スペック値のコンポーネント
        'spec-values': specValues
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin
    ],
    methods: {
        // すべて選択
        allSelect: function (index) {
            this.$refs.specValues[index].allSelectSpecs();
        }
    }
};

/**
 * 商品スペック設定コンポーネント
 */
export default {
    name: 'specSelector',
    template: '#spec_selector_component_template',
    data () {
        return {
            // 商品スペックリスト
            specs: [],
            // 選択中のスペックデータ
            selected_specs: [],
            // 選択中のスペックデータ(表示用)
            display_selected_specs: [],
        };
    },
    props: {
        // プロダクトカテゴリID
        product_id: {
            type: String,
            default: null
        },
        // v-modelの値
        modelValue: {
            type: Array
        }
    },
    components: {
        'spec-list': specList,
    },
    async mounted () {
        await this.getSpecs();

        // 既に選択されたスペックデータが親から送られてきている場合
        if (this.modelValue?.length > 0) {
            this.modelValue.forEach(function (select_spec) {
                this.setSelectedSpecs(select_spec.id, select_spec.values);
            }, this);

            this.setDisplaySelectedSpecs();
        }
    },
    watch: {
        // プロダクトカテゴリIDが変更されたら商品スペックデータを取得しなおす
        product_id: {
            async handler() {
                await this.getSpecs();

                await this.initSelectedSpecs();
            },
        }
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin
    ],
    emits: ['update:modelValue'],
    methods: {
        // 商品コードをもとにスペック情報を取得
        getSpecs: async function () {
            // 初期化
            this.specs = [];

            let message = this.exception_error_message;

            try {
                this.$_loading();

                const response = await axios.get('/spec/get_product_spec', {
                    params: {
                        product_id: this.product_id
                    }
                });
                if (response.data.status == 'OK') {
                    // 商品スペックデータをセット
                    this.specs = response.data.specs;
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }

            this.$_unloading();
        },
        // 選択されているスペック情報の初期化
        initSelectedSpecs: function () {
            this.display_selected_specs = [];

            this.selected_specs = [];
            if (this.specs && this.specs.length > 0) {
                this.specs.forEach(function (spec) {
                    let spec_value = '';

                    // 複数チェックボックスの場合は初期値を配列にする
                    if (spec.spec_values[0].selection_type == 1 && spec.spec_values[0].data_type == 1) {
                        spec_value = [];
                    }

                    this.setSelectedSpecs(spec.spec_id, spec_value);
                }, this);
            }
        },
        // モーダルオープン
        show: async function () {
            // ヤフーyahooAPI用アクセストークンが有効かチェック(トークンがリフレッシュされる)
            if (!await this.$root.$refs.yahooAuth.isValidToken()) {
                return;
            }

            const specValuesComponents = this.$refs.specList.$refs.specValues;
            for(let i in specValuesComponents) {
                let specValuesComponent = specValuesComponents[i];
                specValuesComponent.setSelectedSpecs();
            }

            this.open();
        },
        // 選択したスペックをセット
        setSelectedSpecs: function (spec_id, spec_value) {
            this.selected_specs[spec_id] = spec_value;
        },
        setDisplaySelectedSpecs: function () {
            let displaySelectedSpecs = [];
            for (let i in this.specs) {
                let spec = this.specs[i];
                if (spec.spec_id in this.selected_specs) {
                    let displaySelectedSpec = {
                        spec_name: '',
                        spec_values: []
                    };

                    let selected_spec = this.selected_specs[spec.spec_id];

                    // スペック名格納
                    displaySelectedSpec['spec_name'] = spec.spec_name;

                    let selection_type = spec.spec_values[0].selection_type;
                    let data_type = spec.spec_values[0].data_type;

                    // スペック値が「整数」 or 「小数点整数」データの場合
                    if (
                        selection_type == 0 &&
                        (data_type == 2 || data_type == 4) &&
                        selected_spec.length
                    ) {
                        displaySelectedSpec['spec_values'].push(selected_spec);
                    }

                    // スペック値が「ラジオ選択肢」データの場合
                    if (selection_type == 0 && data_type == 1) {
                        let spec_values = 'なし';
                        for (let j in spec.spec_values) {
                            let spec_value = spec.spec_values[j];
                            if (spec_value.spec_value_id == selected_spec) {
                                spec_values = spec_value.spec_value_name;
                                break;
                            }
                        }
                        displaySelectedSpec['spec_values'].push(spec_values);
                    }

                    // スペック値が「複数チェックボックス」データの場合
                    if (
                        selection_type == 1 &&
                        data_type == 1 &&
                        selected_spec.length
                    ) {
                        for (let j in spec.spec_values) {
                            let spec_value = spec.spec_values[j];
                            if (selected_spec.includes(spec_value.spec_value_id)) {
                                displaySelectedSpec['spec_values'].push(spec_value.spec_value_name);
                            }
                        }
                    }

                    displaySelectedSpecs.push(displaySelectedSpec);
                }
            }

            this.display_selected_specs = displaySelectedSpecs;
        },
        // 設定したスペックデータを更新
        save: function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            this.emitUpdateSelectedSpecs();

            this.setDisplaySelectedSpecs();

            this.close();
        },

        // -------------------------
        // emit
        // -------------------------

        // 親へ通知
        emitUpdateSelectedSpecs: function () {
            // サーバー側に渡す形に変形
            let data = [];
            this.selected_specs.forEach(function (values, spec_id) {
                if (values.length) {
                    data.push({
                        id: spec_id,
                        values: Array.isArray(values) ? values : new Array(values)
                    });
                }
            });

            this.$emit('update:modelValue', data);
        }
    }
};